import NormalAPI from "../../api";
import urls from "../../api/urls";

// Fetch all pincodes serviceability data
export const getAllPincodesServiceability = async () => {
  try {
    const response = await NormalAPI.Api(
      `${urls.GET_ALL_PINCODES_SERVICEABILITY}?is_active=true`
    ).getCustomHeader();

    if (response?.response?.status === 200) {
      return {
        data: response?.response?.data?.data || [],
        total: response?.response?.data?.total || 0,
      };
    } else {
      throw new Error(response?.response?.data?.message || "API request failed");
    }
  } catch (error) {
    console.error("Error fetching all pincodes serviceability:", error);
    throw error;
  }
};
